import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { encryptId } from '../Auth/encryptUtils';

const QRCodeComponent = ({ studentId }) => {
  const studentIdStr = String(studentId); // ✅ Ensure it's a string
  // const qrValue = encryptId(studentIdStr); // Encrypt the string

  if (!studentIdStr) return <p>Error: Could not generate QR code</p>;

  return (
    <div style={{ textAlign: 'center', margin: '20px 0' }}>
      <QRCodeCanvas value={studentIdStr} size={150} />
      <h3 className='card-title'>Scan QR Code</h3>
    </div>
  );
};

export default QRCodeComponent;
